import { useEffect } from "react";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

import theme from "assets/theme";
import AboutPage from "studio-edifique/pages/AboutPage";
import BlogArticlePage from "studio-edifique/pages/BlogArticlePage";
import BlogPage from "studio-edifique/pages/BlogPage";
import ContactPage from "studio-edifique/pages/ContactPage";
import PortfolioPage from "studio-edifique/pages/PortfolioPage";
import TeamPage from "studio-edifique/pages/TeamPage";
import NotFoundPage from "studio-edifique/pages/NotFoundPage";
import ServicesPage from "studio-edifique/pages/ServicesPage";
import ServicePage from "studio-edifique/pages/ServicePage";
import ProjectPage from "studio-edifique/pages/ProjectPage";
import Analytics from "studio-edifique/components/Analytics";

export default function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<AboutPage />} />
        <Route path="/sobre-nos" element={<Navigate to="/" replace />} />
        <Route path="/servicos" element={<ServicesPage />} />
        <Route path="/servicos/:slug" element={<ServicePage />} />
        <Route path="/projetos/:slug" element={<ProjectPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/time" element={<TeamPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogArticlePage />} />
        <Route path="/contato" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Analytics />
    </ThemeProvider>
  );
}
